import { observable, action, computed } from 'mobx'

type LoadPageFunc = (pageNum: number, pageSize) => any
type NextFunc = (id: any) => any

class PageStore {
    @observable public total: number = 0
    @observable public pageNum: number = 0
    @observable public pageSize: number = 10
    @observable public rows: any[] = []
    @observable public index: number = 0
    public loadPageRows: LoadPageFunc
    public gotoPage: NextFunc

    @action
    public clear() {
        this.total = 0
        this.pageNum = 0
        this.pageSize = 10
        this.rows = []
        this.index = 0
        this.loadPageRows = undefined
        this.gotoPage = undefined
    }

    @computed
    public get disablePrevious() {
        return this.pageNum === 1 && this.index === 0
    }

    @computed
    public get disableNext() {
        return (this.pageNum - 1) * this.pageSize + this.index === this.total - 1
    }

    @computed
    public get size() {
        return this.rows.length
    }

    @computed
    public get totalPage() {
        const mod = this.total % this.pageSize
        const result = this.total / this.pageSize
        return mod > 0 ? Math.floor(result) + 1 : result
    }

    @action
    public init(total: number, pageNum: number, pageSize: number,
                rows: any[], index: number, loadPageRows: LoadPageFunc, gotoPage: NextFunc) {
        this.total = total
        this.pageNum = pageNum
        this.pageSize = pageSize
        this.rows = rows
        this.index = index
        this.loadPageRows = loadPageRows
        this.gotoPage = gotoPage
    }

    @action
    public setRows(data: any[]) {
        this.rows = data
    }

    @action
    public next() {
        if (this.index + 1 < this.size) {
            const nextIndex = this.index + 1
            this.index = nextIndex
            const nextRow = this.rows[nextIndex]
            this.gotoPage(nextRow)
        } else {
            // 向后翻页
            if (!this.disableNext) {
                const nextPage = this.pageNum + 1
                this.pageNum = nextPage
                this.loadPageRows(nextPage, this.pageSize).then(() => {
                    this.index = 0
                    const nextRow = this.rows[0]
                    this.gotoPage(nextRow)
                })

            }
        }
    }

    @action
    public previous() {
        if (this.index > 0) {
            const previousIndex = this.index - 1
            this.index = previousIndex
            const previousRow = this.rows[previousIndex]
            this.gotoPage(previousRow)
        } else {
            // 向前翻页
            if (this.pageNum > 1 && this.index === 0) {
                const previousPageNum = this.pageNum - 1
                this.pageNum = previousPageNum
                this.loadPageRows(previousPageNum, this.pageSize).then(() => {
                    this.index = this.pageSize - 1
                    const previousRow = this.rows[this.index]
                    this.gotoPage(previousRow)
                })
            }
        }
    }
}

export default PageStore
